<div [ngClass]="filterConfig.borderless ? 'search-filter' : 'input-group'">
  <span [class.input-group-addon]="!filterConfig.borderless">
    <mat-icon class="bold" svgIcon="magnifier" aria-label="Search" role="img"></mat-icon>
  </span>
  <input
    #searchInput
    tabindex="0"
    id="{{ filterConfig.id }}"
    type="text"
    class="form-control"
    [attr.placeholder]="filterConfig.placeholder || 'Search'"
    [(ngModel)]="search.query"
    (keyup.enter)="searchAction(0)"
    (ngModelChange)="searchAction(1000)"
    [focusMe]="focus"
    [attr.aria-label]="filterConfig.placeholder || 'Search'"
    name="search"
  />
</div>
